import { render } from "./DuplicateInstance.vue?vue&type=template&id=7e75485a"
import script from "./DuplicateInstance.vue?vue&type=script&lang=js"
export * from "./DuplicateInstance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__